/**
 * Jedyna reguła ważności sesji zapisanej w magazynie przeglądarki.
 *
 * Wcześniej ta sama decyzja żyła w dwóch odwróconych kopiach — w automatycznym
 * logowaniu i w strażniku trasy konta — więc dla tych samych danych potrafiły
 * odpowiedzieć inaczej: nagłówek pokazywał zalogowanego, a wejście na konto
 * odbijało na stronę główną.
 */
export function isSessionValid(
  accessToken: string | null | undefined,
  expiresAt: string | null | undefined,
): boolean {
  if (!accessToken || !expiresAt) {
    return false;
  }

  const expiresAtTime = new Date(expiresAt).getTime();

  // Data, której przeglądarka nie umie odczytać, daje NaN, a każde porównanie
  // z NaN jest fałszywe — także to odwrotne. Dlatego odrzucamy taką wartość
  // wprost: śmieć w magazynie znaczy „brak ważnej sesji”, nigdy „sesja ważna”.
  if (Number.isNaN(expiresAtTime)) {
    return false;
  }

  return expiresAtTime > Date.now();
}
